import type { Module } from "vuex";
import type { State } from "@/store/state";
import type { DeviceState } from "./state";
import { mutations } from "./mutations";
import { getters } from "./getters";
import { actions } from "./actions";

const defaultState: DeviceState = {
  devices: [],
};

export const devicesModule: Module<DeviceState, State> = {
  namespaced: true,
  state: defaultState,
  mutations,
  actions,
  getters,
};
